<template>
  <div>
    <LoadingPage v-if="isLoadPage" />
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
      <!-- Card stats -->
      <b-row> </b-row>
    </base-header>
    <b-container fluid class="mt--7">
      <b-col lg="12">
        <card header-classes="bg-transparent">
          <b-row class="mb-4">
            <b-col lg="8" xl="10" md="12" class="d-flex flex-column mb-4">
              <h2 slot="header" class="mb-0">จัดการพนักงานขับรถ</h2>
              <div class="text-body-1">
                แสดงตารางรายละเอียดพนักงานขับรถทั้งหมดที่มีอยู่
              </div>
            </b-col>
            <b-col lg="4" xl="2" md="12" class="text-right">
              <base-button
                type="primary"
                class="d-flex align-items-center"
                block
                @click="openModalDriver()">
                <b-icon icon="plus" class="mr-2"></b-icon> เพิ่มพนักงาน
              </base-button>
            </b-col>
          </b-row>
          <b-row class="justify-content-end">
            <b-col lg="4" md="12" class="mb-2">
              <b-form-input placeholder="ค้นหาพนักงานหรือทะเบียนรถ">
              </b-form-input>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col>
              <b-table responsive :fields="fields" :items="drivers">
                <template #cell(index)="data">
                  {{
                    (pagination.currentPage - 1) * pagination.perPage +
                    data.index +
                    1
                  }}
                </template>
                <template #cell(firstname)="data">
                  {{ data.item.firstname }} {{ data.item.lastname }}
                </template>
                <template #cell(manage)="data">
                  <b-button
                    variant="outline-border"
                    size="sm"
                    @click="
                      $router.push({
                        name: 'manageDriverId',
                        params: { id: data.item.id },
                      })
                    ">
                    <b-icon icon="pencil-square"></b-icon>
                  </b-button>
                  <b-button
                    @click="openModalConfirm(data.item.id)"
                    variant="outline-danger"
                    size="sm">
                    <b-icon icon="trash-fill"></b-icon>
                  </b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="d-flex justify-content-end">
              <b-pagination
                v-model="pagination.currentPage"
                :disabled="isLoading"
                :total-rows="pagination.totalRows"
                :per-page="pagination.perPage"
                aria-controls="my-table"
                class="mt-3"
                @change="(page) => getDriver(page)"></b-pagination>
            </b-col>
          </b-row>
        </card>
      </b-col>
      <ModalDriver :form="form" @getDriver="getDriver" />
      <ModalConfirm
        ref="confirmDelete"
        :confirm="confirm"
        @confirmModal="onDeleteDriver" />
    </b-container>
  </div>
</template>
<script>
import { modalSuccess, modalError } from "@/util/alert.js";
import driverServices from "@/api/driver.service.js";
import ModalDriver from "@/components/Driver/ModalDriver.vue";
import ModalConfirm from "@/components/Modal/Alert/ModalConfirm.vue";
import { getCancelToken } from "@/util/axiosCancel";

export default {
  components: { ModalDriver, ModalConfirm },
  props: {},
  data() {
    return {
      isLoadPage: false,
      drivers: [],
      searchTerm: "",
      isLoading: false,
      pagination: {
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
      },
      fields: [
        {
          key: "index",
          label: "#",
        },
        {
          key: "email",
          label: "username",
        },
        {
          key: "firstname",
          label: "ชื่อ-นามสกุล",
        },
        {
          key: "vehicle.drive_system",
          label: "ประเภทรถ",
        },
        {
          key: "vehicle.plate",
          label: "ทะเบียนรถ",
        },
        {
          key: "phonenumber",
          label: "เบอร์โทรศัพท์",
        },
        {
          key: "manage",
          label: "การจัดการ",
        },
      ],
      form: {
        show: false,
        isLoad: false,
        driver: {
          username: null,
          password: null,
          firstName: null,
          lastName: null,
          tel: null,
          car: null,
        },
      },
      confirm: {
        show: false,
        icon: '<i class="fas fa-times-circle text-red fa-5x"></i>',
        emphasize: "ต้องการลบรายการ",
        text: "กรุณาตรวจสอบข้อมูล หากลบรายการแล้วจะไม่สามารถกู้คืนได้",
        isLoad: false,
        id: null,
      },
    };
  },
  created() {
    this.getDriver();
  },
  methods: {
    async getDriver(page = 1) {
      this.isLoading = true;
      this.isLoadPage = true;
      try {
        const cancelToken = getCancelToken();
        const response = await driverServices.getDriver(
          {
            page,
            filters: this.searchTerm,
          },
          cancelToken
        );

        this.drivers = response.data.data.items;
        this.pagination.totalRows = response.data.data.meta.totalItems;
        this.pagination.perPage = response.data.data.meta.itemsPerPage;
        this.pagination.currentPage = response.data.data.meta.currentPage;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
        this.isLoadPage = false;
      }
    },
    openModalDriver() {
      this.form.show = true;
    },
    async onDeleteDriver() {
      try {
        this.isLoadPage = true;

        await driverServices.removeDriver(this.confirm.id);
        modalSuccess(this.$bvModal, "ลบพนักงานขับรถสำเร็จ");
        this.getDriver();
        this.$refs.confirmDelete.closeModalConfirm();
      } catch (error) {
        modalError(this.$bvModal, "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      } finally {
        this.isLoadPage = false;
      }
    },
    openModalConfirm(driverId) {
      this.confirm.show = true;
      this.confirm.id = driverId;
      this.confirm.icon = '<i class="fas fa-times-circle text-red fa-5x"></i>';
      this.confirm.emphasize = "ต้องการลบรายการ";
      this.confirm.text =
        "กรุณาตรวจสอบข้อมูล หากลบรายการแล้วจะไม่สามารถกู้คืนได้";
    },
  },
  props: {},
  mounted() {},
};
</script>
<style scoped></style>
<style lang="scss" scoped></style>
